module.exports = __webpack_public_path__ + "Tinebase/js/ace-html_ruby-FAT.js";